var main = require('client_core/main');

main.baseFiles.spinner = require('./components/spinner');
main.baseFiles.base = require('./product/base');

module.exports = main;